import React ,{useRef ,useEffect}from 'react';
import moment from 'moment'
import IrtizaDynamicInputList from '../irtiza-dynamic-input/irtiza-dynamic-input-list';
// import IrtizaDynamicInputAddNewList from '../irtiza-dynamic-input/irtiza-dynamic-input-add-new-list';
import SecurityService from '../security/security.service';
import BudgetItemInfoAdd  from './budget-item-info-add'
import BudgetItemInfoService from './budget-item-info.service';
// import AuditTableInput from '../audit-table/audit-table'
import './budget-item-info.scss'


const BudgetItemInfoInput = (props) => {



// BrandID
// BrandName
    let columns =[
        {  field: "BudgetItemID",headerText:'ID',width:'90px',textAlign:'right' ,headerTextAlign:'center',other:[{allowEditing:false}]},
        {  field: "BudgetItem",headerText:'Full Yarn Count Name',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        // {  field: "BrandVendorName",headerText:'Brand Vendor Name',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        ]

       const listActionComplete = async (grid , args ,getListService ,selectedRow )=>{
        console.log(args )
        console.log(getListService )
        console.log(selectedRow )
        if (args.requestType === 'beginEdit' || args.requestType === 'add') {
          // if(args.requestType == 'add'){
          //   setTimeout(()=>document.getElementById('BrandGridBrandName').focus(),400)
          // }
          // document.getElementById('BrandGridBrandName').addEventListener('blur', async (e)=>{
          //   setTimeout(() => document.getElementById('BrandGridBrandName') && grid?.endEdit(), 200);
           
          // })
          }
        if (args.requestType == 'save' || args.requestType == 'cancel' ) {
          getListService()

        }
        if(args.requestType == 'save'){
          let data = {
            BudgetItemID:args.data.BudgetItemID,
            BudgetItem:args.data.BudgetItem,
            BudgetCategoryID:args.data.BudgetCategoryID
          }
          console.log(data)
        if(args.action == 'add'){
          BudgetItemInfoService.insert(data).then(async (res)=>{
            await getListService()
            // setTimeout(()=>document.getElementById('BrandGrid_add').click(),700)

            // let AddData = {
            //   BrandID:args.data.BrandID,
            //   BrandName:args.data.BrandName,
            // }
            // AuditTableInput.auditAdd(`Brand`,`Brand`,`BrandID`,AddData)
          })
        }
        if(args.action == 'edit'){
          BudgetItemInfoService.update(data).then((res)=>{
            getListService()

            // let EditData = {
            //     BrandID:args.data.BrandID,
            //     BrandName:args.data.BrandName
            // }
            // let totalColumns = Object.keys(EditData);
            //             console.log(totalColumns)
            //             AuditTableInput.auditEdit(totalColumns,selectedRow,EditData,`Brand`,args.data.MainBrandID)
          })
        }
        }
        
       }
       //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************

        // Defines the  boolean
        // @default true
    let  allowTemplate = true
    let  allowGrouping = true
    let  allowExcelExport =true
    let  allowPdfExport = true
    let  showColumnChooser = true
    let  allowPaging = false
    let  allowDataBound = true
    let  allowGridSum = false
    let  isDialog = props.IsDialog == true ? true : false

       
        // Defines the  string
        // @default Brand${typeMode} 
        let ListSecurity='Budget Items Information'
        let AddSecurity='Budget Items Information'
        let EditSecurity='Budget Items Information'
        let DeleteSecurity='Budget Items Information'
       
       // Defines the  ['Add','Edit','Delete','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'] | 'All'
       //  @default 'All'
      let toolbarOptions ='All';

      const toolbarClicking =  async (args)=>{
        console.log(args)
      }
      
       // Defines the 'Descending' | 'Ascending'
       //  @default 'Descending'
      let DefaultSortedColumnSort ='Descending';

       /* Defines the [{
                    TableName:'Brand' ,
                    TableID:'BrandID',
                   // Optional if Delete is Soft // TableSecurity:'BrandDelete',
                }]*/
    //  @default [] 
    //   let listDelete =  [{ TableName:'Brand' ,TableID:'BrandID', Optional // TableSecurity:'BrandDelete'}]
    let listDelete = [];
       
    // Defines 'Hard' | 'Soft' 
    // @Default 'Hard'
    let deleteType = 'Hard'


/* Defines the [   {field:'IsDeleted',
OPTIONAL HAI operator:'equal' or more check syncfusion documentation
        value:'No'},...more
        ] | []
      @default [] */
    //   let filterColumns = [{ field: 'IsDeleted', value: 'No' }];
      let filterColumns = [];

      /* Defines the [ColumnNames] | []
      @default [] */
    //   let groupColumns = ['IsDeleted','AccountTitleHawalaDr'];
      let groupColumns = [];

/* Defines the 'Dialog' | 'Normal'
      @default 'Dialog' */
      let gridEditSettingMode = 'Dialog';

/* Defines the '<p></p>' | Can give HTML | AND REACT FUNCTION LIKE HeaderTemplate
      @default '<p></p>' */
      let gridEditSettingHeaderTemplate = '<p></p>';

      /* Defines the  [ColumnNames] | []
      @default [] */
           //   let gridSumColumns = ['HawalaCommissionPercent'];
      let gridSumColumns = [];


    return (
      
        <IrtizaDynamicInputList
        Id='BudgetItemInfo'
        ListTitle='Budget Items - List'
        ColumnsList={columns}
        GridDataSource= {[
                    {
                        DataSourceType: 'Function',
                        // DataSource:  ()=> FullYarnCountInfoService.getBrandForList()
                        DataSource:  ()=> BudgetItemInfoService.getBudgetItemInfoForList()
                        }]}
        DefaultSortedColumnName={'BudgetItemID'}
        GridDialog={[
            {
                DialogType:'Self',
                Dialog:<BudgetItemInfoAdd GridID={'BudgetItemInfo'} />
            }
        ]}
        ListActionComplete={listActionComplete}
        ToolbarClicking ={toolbarClicking}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
            // AllowTemplate={allowTemplate}
            // ToolbarOption={toolbarOptions}
            // AllowGrouping={allowGrouping}
            // AllowExcelExport={allowExcelExport}
            // AllowPdfExport={allowPdfExport} 
            // ShowColumnChooser={showColumnChooser}
            // AllowPaging={allowPaging}
            AllowDataBound={allowDataBound}
            ListSecurity={ListSecurity}
            AddSecurity={AddSecurity}
            EditSecurity={EditSecurity}
            DeleteSecurity={DeleteSecurity}
            // DefaultSortedColumnSort={DefaultSortedColumnSort}
            // FilterColumns={filterColumns} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
            // GroupColumns={groupColumns} 
            // ListDelete={listDelete}
            // DeleteType={deleteType} 
            GridEditSettingMode={gridEditSettingMode}
            // GridEditSettingHeaderTemplate={gridEditSettingHeaderTemplate}
            // GridSumColumns={gridSumColumns}
            // AllowGridSum={allowGridSum}
            IsDialog={isDialog}

            {...props}
            ></IrtizaDynamicInputList>

            );
}



export default BudgetItemInfoInput;
